import styles from "./style.module.css";
import { useRef, useState } from "react";
import { LichtBlickLogoSMA } from "src/assets";
import { useTranslation } from "react-i18next";
import { IntroLB, MobileIntroLB } from "src/assets";
import { DynamicTariffVideo } from "src/assets";
import { Stack, useTheme } from "@mui/material";
import BoldTitle from "src/components/Displays/BoldTitle";

const Header = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const videoRef = useRef<HTMLVideoElement>(null);

  const [showVideo, setShowVideo] = useState({
    width: "0px",
    height: "0px",
  });

  document.addEventListener("fullscreenchange", (event) => {
    if (document.fullscreenElement === null) {
      videoRef.current?.pause();
      setShowVideo({
        width: "0px",
        height: "0px",
      });
    }
  });

  if (videoRef.current) {
    videoRef.current.onpause = function () {
      if (videoRef.current?.seeking) {
        return;
      }
      videoRef.current?.pause();
      setShowVideo({
        width: "0px",
        height: "0px",
      });
    };
  }

  return (
    <>
      <Stack
        sx={{
          my: 2,
          width: "100%",
        }}
      >
        <LichtBlickLogoSMA color="black" />
      </Stack>

      <video
        ref={videoRef}
        className={styles}
        width={showVideo.width}
        height={showVideo.height}
        style={{ marginBottom: showVideo.height === "0px" ? "0px" : "10px" }}
      >
        <source src={DynamicTariffVideo} type="video/mp4" />
      </video>

      <Stack
        sx={{
          alignItems: "center",
          width: "fit-content",
          height: "fit-content",
          maxHeight: "fit-content",
          position: "relative",
          borderRadius: "15px",
          overflow: "hidden",
        }}
      >
        <Stack
          sx={{
            display: { xs: "none", sm: "flex" },
          }}
        >
          <img
            src={IntroLB}
            alt="mobile-intro"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          <Stack
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "250px",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.888), transparent)",
            }}
          />
        </Stack>
        <Stack
          sx={{
            display: { xs: "flex", sm: "none" },
          }}
        >
          <img
            src={MobileIntroLB}
            alt="mobile-intro"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          <Stack
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "250px",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.888), transparent)",
            }}
          />
        </Stack>
        <Stack
          gap={2}
          sx={{
            maxWidth: { xs: "350px", sm: "400px" },
            position: "absolute",
            left: { lg: "201px", md: "100px", sm: "0px" },
            bottom: "29px",
            px: { xs: 4, lg: 0 },
          }}
        >
          <BoldTitle
            color={theme.palette.app.contrast}
            sx={{
              fontSize: { xs: "36px", md: "48px" },
              lineHeight: { xs: "39px", md: "50px" },
            }}
            text={t("page.introduction.newTitleLichtblick")}
          />

          <BoldTitle
            color={theme.palette.app.contrast}
            sx={{
              fontSize: { xs: "24px", md: "36px" },
              lineHeight: { xs: "27px", md: "38px" },
            }}
            text={t("page.introduction.subtitleSMA")}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default Header;
